export default function routes($routeProvider){
    $routeProvider.otherwise({redirectTo: '/login'});

    $routeProvider.when('/login', {
        templateUrl: 'angular/modules/login.html',
        controller: 'LoginController',
        controllerAs: 'vm',
        data: {
            pageTitle: 'Login'
        }
    });

    $routeProvider.when('/packaging', {
        templateUrl: 'angular/modules/packaging.html',
        controller: 'PackagingController',
        controllerAs: 'vm',
        access: {
            requiresLogin: true
        }
    });
}